import { render, staticRenderFns } from "./paper-share-with-user-popup.html?vue&type=template&id=91f1af78&scoped=true&external"
import script from "./paper-share-with-user-popup.js?vue&type=script&lang=js&external"
export * from "./paper-share-with-user-popup.js?vue&type=script&lang=js&external"
import style0 from "./paper-share-with-user-popup.scss?vue&type=style&index=0&id=91f1af78&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f1af78",
  null
  
)

export default component.exports